import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AdminFab from './AdminFab';
import LearnDarkModeToggle from '../content/LearnDarkModeToggle';
import { useLearnDarkMode } from '../../hooks/useLearnDarkMode';
import { pageToneFromPath } from '../../content/pageThemes';

const MainLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { dark, setDark, onLearnView } = useLearnDarkMode();

  return (
    <div className="page-shell flex flex-col min-h-screen max-w-[100vw] overflow-x-clip" data-page-tone={pageToneFromPath(pathname)}>
      <Header />
      <main className="flex-grow page-canvas" data-page-scroll>
        <Outlet />
      </main>
      <Footer />
      {onLearnView && <LearnDarkModeToggle dark={dark} onChange={setDark} />}
      <AdminFab />
    </div>
  );
};

export default MainLayout;
